import React, { Component } from "react";
import RecipeSearch from "../components/RecipeSearch";
import VideosList from "../components/VideosList";

const apiKey = process.env.REACT_APP_API;

export default class Videos extends Component {
  state = {
    recipes: [],
  };

  handleChange = (event) => {
    this.setState({
      term: event.target.value,
    });
  };

  findRecipe = (event) => {
    event.preventDefault();
    const { term } = this.state;
    const apiUrl = `https://api.spoonacular.com/food/videos/search?apiKey=${apiKey}&query=${term}&number=12`;

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          recipes: data.videos,
        });
      });
  };
  componentDidMount() {
    const videos = JSON.parse(localStorage.getItem("videos"));
    if (videos) {
      this.setState({
        recipes: videos,
      });
    }
  }

  componentDidUpdate() {
    const videos = JSON.stringify(this.state.recipes);
    localStorage.setItem("videos", videos);
  }

  render() {
    const { recipes } = this.state;
    return (
      <div>
        <RecipeSearch
          handleChange={this.handleChange}
          findRecipe={this.findRecipe}
        />

        {recipes.length === 0 ? (
          <h1 className="search-heading">Search a new recipe..</h1>
        ) : (
          <VideosList recipes={recipes} />
        )}
      </div>
    );
  }
}
